function SkillGraphIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        width={(size * 23) / 24}
        height={size}
        viewBox='0 0 23 24'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M10.5001 3.08196C11.1234 3.08196 11.6861 2.70576 11.924 2.12967C12.1618 1.55358 12.0296 0.890348 11.5888 0.449591C11.147 0.00983061 10.4838 -0.121378 9.90768 0.118498C9.33261 0.358364 8.95743 0.92113 8.95948 1.54437C8.96153 2.39416 9.65035 3.08196 10.5001 3.08196Z'
          fill='currentColor'
        />
        <path
          d='M10.5001 20.918C9.87681 20.918 9.31406 21.2942 9.07623 21.8703C8.83841 22.4464 8.97065 23.1096 9.41141 23.5504C9.85322 23.9901 10.5164 24.1213 11.0925 23.8815C11.6676 23.6416 12.0428 23.0788 12.0407 22.4556C12.0387 21.6058 11.3498 20.918 10.5001 20.918Z'
          fill='currentColor'
        />
        <path
          d='M20.4985 4C20.4985 5.10446 19.603 6 18.4985 6C17.3941 6 16.4985 5.10446 16.4985 4C16.4985 2.89554 17.3941 2 18.4985 2C19.603 2 20.4985 2.89554 20.4985 4Z'
          fill='currentColor'
        />
        <path
          d='M2.01689 18.3054C1.57611 18.7462 1.44387 19.4094 1.6817 19.9855C1.92055 20.5606 2.48229 20.9368 3.10554 20.9368C3.72878 20.9368 4.29051 20.5606 4.52937 19.9855C4.76821 19.4094 4.63597 18.7462 4.1952 18.3054C3.59245 17.7068 2.61964 17.7068 2.01689 18.3054Z'
          fill='currentColor'
        />
        <path
          d='M20.9559 10.459C20.3326 10.459 19.7709 10.8342 19.532 11.4103C19.2932 11.9853 19.4254 12.6486 19.8662 13.0893C20.307 13.5301 20.9692 13.6613 21.5452 13.4235C22.1213 13.1847 22.4965 12.6229 22.4965 11.9997C22.4965 11.1489 21.8067 10.459 20.9559 10.459Z'
          fill='currentColor'
        />
        <path
          d='M1.0022 11C0.597753 10.9987 0.232559 11.2422 0.0768935 11.6154C-0.0787649 11.9894 0.00638175 12.4199 0.291753 12.7066C0.577794 12.9927 1.00818 13.0786 1.38202 12.9242C1.75587 12.7698 2 12.4045 2 12C2 11.4484 1.55366 11.0013 1.0022 11Z'
          fill='currentColor'
        />
        <path
          d='M20.4998 18.4995C21.2265 19.6736 20.8624 21.2152 19.6883 21.9403C18.5142 22.667 16.9726 22.3028 16.2475 21.1288C15.5224 19.9547 15.885 18.4131 17.059 17.688C18.2331 16.9629 19.7747 17.3254 20.4998 18.4995Z'
          fill='currentColor'
        />
        <path
          d='M4.50115 5.83948C5.21627 5.124 5.4308 4.04747 5.04329 3.11236C4.6558 2.17891 3.74443 1.56826 2.7333 1.56826C1.72216 1.56826 0.810815 2.17891 0.423304 3.11236C0.0374751 4.04747 0.252011 5.12404 0.967105 5.83948C1.94499 6.81118 3.52326 6.81118 4.50115 5.83948Z'
          fill='currentColor'
        />
        <path
          d='M4.37417 6.27191L7.12642 9.00053C7.2443 8.86932 7.36936 8.74426 7.50058 8.62638L4.76355 5.89355H4.76458C4.70922 5.96941 4.64977 6.04219 4.58416 6.11087C4.51753 6.1693 4.44798 6.22271 4.37417 6.27191Z'
          fill='currentColor'
        />
        <path
          d='M10.781 20.3789V16.499H10.5001H10.2192V20.3605V20.3595C10.3125 20.3482 10.4058 20.3421 10.5001 20.341C10.5944 20.3462 10.6887 20.3584 10.781 20.3789Z'
          fill='currentColor'
        />
        <path
          d='M16.6259 17.7276L13.8737 14.999C13.7578 15.1323 13.6328 15.2573 13.4995 15.3732L16.2365 18.1102C16.297 18.0395 16.3493 17.9605 16.417 17.8929H16.4159C16.4826 17.8334 16.5521 17.7779 16.6259 17.7276Z'
          fill='currentColor'
        />
        <path
          d='M10.2192 3.62503V7.50094H10.5001H10.781V3.62109C10.6887 3.63647 10.5944 3.64365 10.5001 3.64365C10.4058 3.64365 10.3125 3.63631 10.2192 3.62503Z'
          fill='currentColor'
        />
        <path
          d='M6.00112 12.2805V11.9996V11.7188H2.12519C2.13647 11.812 2.14365 11.9053 2.14365 11.9996C2.14365 12.0939 2.13647 12.1882 2.12109 12.2805H6.00112Z'
          fill='currentColor'
        />
        <path
          d='M4.37402 17.7319C4.4509 17.7852 4.52368 17.8437 4.59134 17.9083C4.65694 17.9769 4.71742 18.0507 4.77175 18.1286L7.50878 15.3916V15.3927C7.37347 15.2686 7.24636 15.1364 7.12643 14.999L4.37402 17.7319Z'
          fill='currentColor'
        />
        <path
          d='M18.879 12.2805C18.8637 12.1882 18.8565 12.0939 18.8565 11.9996C18.8565 11.9053 18.8637 11.812 18.8749 11.7188H14.999V11.9996V12.2805H18.879Z'
          fill='currentColor'
        />
        <path
          d='M16.629 6.27175C16.5511 6.21742 16.4773 6.15694 16.4087 6.09134C16.3441 6.02368 16.2856 5.9509 16.2323 5.87402L13.4995 8.62626C13.6369 8.74312 13.7681 8.8692 13.8931 9.00042L16.629 6.27175Z'
          fill='currentColor'
        />
        <path
          d='M14.466 12.0001C14.466 14.1907 12.6906 15.966 10.5001 15.966C8.3096 15.966 6.53418 14.1906 6.53418 12.0001C6.53418 9.8096 8.3096 8.03418 10.5001 8.03418C12.6906 8.03418 14.466 9.8096 14.466 12.0001Z'
          fill='currentColor'
        />
      </svg>
    </span>
  );
}

export default SkillGraphIcon;
